import {
  CryptoTable,
  TrendingCoins,
} from '../../../components/dashboard-components/crypto-comp/CryptoComp';
import React, { useEffect, useState } from 'react';
import { BsBoxArrowInDown, BsBoxArrowInUp } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import axios from 'axios';
import BalanceSummary from '../../../components/dashboard-components/balance-summary/BalanceSummary';
import { useGlobalContext } from '../../../context/context';
import secureLocalStorage from 'react-secure-storage';
import { useDisclosure } from '@mantine/hooks';
import { NotificationModal } from '../../../components/dashboard-components/modals/Modals';

const Overview = () => {
  const [balanceData, setBalanceData] = useState([]);
  const [notification, setNotification] = useState({});
  const { baseURL } = useGlobalContext();
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const [opened, { open, close }] = useDisclosure(false);

  const fetchUser = async () => {
    try {
      const { data } = await axios.get(
        `${baseURL}/users/user-info?fields=bonus profits deposits withdrawals pendingDeposits pendingWithdrawals totalBalance notification signalStrength`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotification(data.notification);
      setBalanceData(data);
      if (data.notification.title && data.notification.content) {
        open();
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content overview-page'>
      <section className='balances'>
        <div className='fiat-balance'>
          <div className='balance'>
            <div className='info'>
              <p>Total Profit</p>
              <h3>
                $<span>{balanceData.profits?.toLocaleString(`en-US`)}</span>
                .00
              </h3>
            </div>
          </div>
          <div className='btns'>
            <Link to='/dashboard/deposit'>
              <button className='linear'>
                <BsBoxArrowInDown />
                Deposit
              </button>
            </Link>
            <Link to='/dashboard/withdrawal'>
              <button className='linear'>
                <BsBoxArrowInUp />
                Withdraw
              </button>
            </Link>
          </div>
        </div>
        <BalanceSummary balanceData={balanceData} />
      </section>

      <TrendingCoins />
      <CryptoTable />
      {notification.title && notification.content && !notification.seen && (
        <NotificationModal
          opened={opened}
          closeFunc={close}
          notification={notification}
        />
      )}
    </main>
  );
};

export default Overview;
